const City = {

    // FIELDS
    "name": "الاسم",
    "status": "الحالة",
    "search": "بحث",
    "country": "البلد",
    "state": "الولاية",

    // PAGE HEADER
    "city": "مدينة",

    // ERROR
    "error_name": "ادخل الاسم",
    "error_country": "اختر البلد",
    "error_state": "اختر الولاية",
    "error_status": "اختر الحالة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_state": "الولاية",
    "table_country": "الدولة",
    "table_status": "الحالة",

}

export default City;
